import {
    FRAUD_FAILURE,
    FRAUD_LOAD,
    FRAUD_SUCCESS,
    FRAUD_COUNT_FAILURE,
    FRAUD_COUNT_LOAD,
    FRAUD_COUNT_SUCCESS,
    REQUEST_FRAUD_FAILURE,
    REQUEST_FRAUD_LOAD,
    REQUEST_FRAUD_SUCCESS
} from './fraudActions';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                fraud: []
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_LOAD:
            newState = {
                ...state,
                error: null,
                fraud: [],
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_SUCCESS:
            newState = {
                ...state,
                fraud: action.fraud,
                loading: false,
                pages: action.pages
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_COUNT_LOAD:
            newState = {
                ...state,
                countError: null,
                countLoading: true,
                count: 0
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_COUNT_SUCCESS:
            newState = {
                ...state,
                countLoading: false,
                count: action.count
            };

            return isEqual(state, newState) ? state : newState;

        case FRAUD_COUNT_FAILURE:
            newState = {
                ...state,
                countError: action.error,
                countLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case REQUEST_FRAUD_LOAD:
            newState = {
                ...state,
                requestFraudError: null,
                requestFraudLoading: true,
                requestFraudSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case REQUEST_FRAUD_FAILURE:
            newState = {
                ...state,
                requestFraudError: action.error,
                requestFraudLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case REQUEST_FRAUD_SUCCESS:
            newState = {
                ...state,
                requestFraudLoading: false,
                requestFraudSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getFraudEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'fraud')
);

export const getPages = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'pages')
);

export const getFraudCount = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'count')
);

export const getIsFraudCountLoading = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'countLoading')
);

export const getFraudCountError = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'countError')
);

export const getFraudCountErrorMessage = createSelector(
    getFraudCountError,
    (error) => get(error, 'message')
);

export const getIsFraudLoading = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'loading')
);

export const getFraud = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'fraud')
);

export const getFraudError = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'error')
);

export const getFraudErrorMessage = createSelector(
    getFraudError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'hasMore')
);

export const getIsRequestFraudLoading = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'requestFraudLoading')
);

export const getIsRequestFraudSuccessful = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'requestFraudSuccessful')
);

export const getRequestFraudError = createSelector(
    getFraudEntity,
    (entity) => get(entity, 'requestFraudError')
);

export const getRequestFraudErrorMessage = createSelector(
    getRequestFraudError,
    (entity) => get(entity, 'message')
);
